import { CommandProps, Node, RawCommands } from '@tiptap/react';

export interface PlaceholderExtensionItems {
  value: string;
  label: string;
}

declare module '@tiptap/react' {
  interface Commands<ReturnType> {
    placeholderDropdown: {
      insertPlaceholder: (placeholder: PlaceholderExtensionItems) => ReturnType;
    };
  }
}

declare module '@tiptap/core' {
  interface Storage {
    placeholderDropdown: {
      items: PlaceholderExtensionItems[];
    };
  }
}

const PlaceholderExtension = Node.create<{
  items: PlaceholderExtensionItems[];
}>({
  name: 'placeholderDropdown',
  group: 'inline',
  inline: true,
  selectable: true,
  atom: true,

  addOptions() {
    return {
      items: [],
    };
  },

  addAttributes() {
    return {
      value: {
        default: null,
      },
      label: {
        default: null,
      },
    };
  },

  addStorage() {
    return {
      items: [],
    };
  },

  onCreate() {
    this.storage.items = this.options.items;
  },

  parseHTML() {
    return [
      {
        tag: 'span',
        getAttrs: element => {
          if (element.getAttribute('data-type') === 'placeholder') {
            return {
              'data-type': 'placeholder',
              value: element.innerHTML,
            };
          }
          return false;
        },
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'span',
      {
        ...HTMLAttributes,
        'data-type': 'placeholder',
      },
      `${HTMLAttributes.value}`,
    ];
  },

  addNodeView() {
    return ({ node }) => {
      const dom = document.createElement('span');
      if (node.attrs.value !== null) {
        dom.setAttribute('value', node.attrs.value);
      }
      dom.setAttribute('data-type', 'placeholder');
      dom.textContent = node.attrs.label ?? node.attrs.value;
      return { dom };
    };
  },

  addCommands() {
    return {
      insertPlaceholder:
        (placeholder: PlaceholderExtensionItems) =>
        ({ chain }: CommandProps) => {
          return chain()
            .insertContent({
              type: this.name,
              attrs: placeholder,
            })
            .run();
        },
    } as Partial<RawCommands>;
  },
});

export { PlaceholderExtension };
